import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import interfaceSettings from './modules/interface.module'
import user from './modules/user.module'
import users from './modules/users.module'
import demandProfiles from './modules/demandProfiles.module'
import gameVersions from './modules/gameVersions.module'
import companies from './modules/companies.modules'
import games from './modules/games.module'
import instructions from './modules/instructions.module'
import orders from './modules/tokens.module'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    interfaceSettings,
    user,
    users,
    demandProfiles,
    instructions,
    gameVersions,
    games,
    companies,
    orders
  },
  strict: debug,
  plugins: [createPersistedState({
    key: 'vuex-admin-bg2',
    paths: ['user', 'interfaceSettings']
  })]
})